export default {
  banner: {
    title: "Access Gateway",
    subtitle:
      "Access gateway gives old applications the ability to quickly integrate Authing. While expanding the identity authentication method, it protects the original system from illegal infringements.",
  },
  features: {
    data1: {
      label: "Reduce operation cost",
    },
    data2: {
      label: "Reduce security risks",
    },
    data3: {
      label: "Increase productivity",
    },
    item1: {
      title:
        "Intelligent security protection accompanies every access management of the application",
      list1: {
        title: "Centralized access management",
        descript:
          "Your hybrid cloud needs more secure access management. Through centralized access control, you can create efficient and unified security policies for local applications.",
      },
      list2: {
        title: "Intelligent security",
        descript:
          "The locally deployed access gateway uses intelligent security protection to provide a security protection layer for the application system.",
      },
    },
    item2: {
      title: "Lightweight architecture, Low-cost operation",
      img: "gateway-integartion-framework-new-en.png",
      descript:
        "The reduction in the proportion of infrastructure operation and maintenance costs is critical for enterprises. Access integration gateways can reduce identity infrastructure by 90%, which means that fewer computing resources and maintenance costs are required, greatly reducing enterprise operating costs, and ensuring data security.",
    },
    item3: {
      title: "Developer-friendly, Zero-code integration",
      descript:
        "Without changing the application system code, it can do identity integration with old applications, quickly support dozens of authentication methods, and save the high cost of application integration.",
    },
  },
  functions: {
    title: "With efficient features, help your business to a higher level",
    item1: {
      title: "Lifecycle management",
      descript:
        "Quickly and efficiently manage applications through application lifecycle management features: including application creation, enabling, disabling, maintenance, and deletion.",
    },
    item2: {
      title: "Flow control",
      descript:
        "The frequency of user and source IP requests can be controlled for specific interfaces to ensure the stable operation of back-end services.",
    },
    item3: {
      title: "Application monitoring",
      descript:
        "Provide real-time and visual application monitoring, including: interface request times, interface call delays, and interface error information. Through the monitoring panel, you can understand the interface call situation more clearly, identify potential risks that may affect the business, and notify in time through multiple notification methods To the relevant person in charge.",
    },
    item4: {
      title: "Access control",
      descript:
        "The access gateway can interact with the identity authentication platform, and synchronize the user, role, access strategy and other information in the identity authentication platform to the gateway side, and determine the user access authority on the gateway side to realize the application access user authority The static and dynamic allocation.",
    },
    item5: {
      title: "Security audit log",
      descript:
        "All application systems have a unified entrance and exit and centralized log management. The only access service exposed to the outside is the gateway service, which dynamically processes user requests according to policies. All access requests through the gateway will be unified for user login verification and authorization.",
    },
  },
  process: {
    title: "Authing Access Gateway Authentication Process",
  },
};
